export default "__VITE_ASSET__CfEZg4Sw__"